import { useEffect, useState } from 'react';
import { createForm, FormType } from 'shared-ui/lib/customs/form/FormGenerator';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import { useFindVehicleQuery } from '../../generated/graphql';
import { faultInputs } from '../../inputs/fault.inputs';

export type FaultFormBody = {
  description: string;
  photo: string;
  vehicleId: string;
};

export type UseFaultFormResult = {
  form: FormType | null;
  loading: boolean;
  hasVehicles: boolean;
};

export const useFaultForm = (): UseFaultFormResult => {
  const [form, setForm] = useState<FormType | null>(null);
  const { data, loading } = useFindVehicleQuery();
  const hasVehicles = (data?.vehicles.list.length ?? 0) > 0;

  useEffect(() => {
    if (loading || !data?.vehicles) {
      setForm(null);
      return;
    }

    const fieldId = faultInputs.vehicleId;
    const f: FormInput[] = [faultInputs.description, faultInputs.photo];
    fieldId.props.options = data.vehicles.list.map((v) => {
      const displayName = v.name || v.registerNumber || v.VIN || 'Ajoneuvo';
      const brandModel = [v.brand, v.model].filter(Boolean).join(' ');
      const regVin = [v.registerNumber, v.VIN].filter(Boolean).join(', ');

      let label = displayName;

      if (brandModel && regVin) {
        label = `${displayName}, ${brandModel} (${regVin})`;
      } else if (brandModel) {
        label = `${displayName}, ${brandModel}`;
      } else if (regVin) {
        label = `${displayName} (${regVin})`;
      }

      return {
        value: v.id,
        label,
      };
    });
    f.push(fieldId);
    setForm(createForm(f));
  }, [data, loading]);

  return { form, loading, hasVehicles };
};
